<template>
  <block-template
    :data="data"
    title="Изображение"
    :possible-next="possibleNext"
    :is-last="isLast"
  >
    <v-img :src="data.content" alt="" />
  </block-template>
</template>

<script>
import BlockTemplate from "./Template";
export default {
  name: "BlockImage",
  components: { BlockTemplate },
  props: {
    data: {
      type: Object,
      required: true,
      content: {
        type: String,
        required: true
      },
      parent_type: {
        type: String,
        required: true
      },
      parent_id: {
        type: Number,
        required: true
      }
    },
    possibleNext: {
      type: Object,
      required: true
    },
    isLast: {
      type: Boolean,
      default: false
    }
  }
};
</script>
